import React, { FC } from 'react';
import { Text } from '@carnica/ui-kit';
import { getLocalCurrencyStr } from '@beef/utils';
import { withRenderFlag } from '@beef/react';

import { getWriteOffText } from 'utils/common';
import { TARIFF_TEXTS } from 'constants/tariff';

export type BillingProps = {
  billingDate?: string;
  isMobile?: boolean;
  period?: number;
  price?: number;
};

const VALID_PERIODS: (number | undefined)[] = [1, 30];

const _Billing: FC<BillingProps> = ({ price, billingDate, period, isMobile = true }) => {
  const text = getWriteOffText(billingDate, period);

  if (!text) {
    return null;
  }

  return (
    <Text color="secondary" variant={isMobile ? 'body-small' : 'body-medium'}>
      {`${text} ${TARIFF_TEXTS.billingText} ${getLocalCurrencyStr(price)}`}
    </Text>
  );
};

const shouldRenderFn = ({ price, billingDate, period }: BillingProps) => {
  if (!(typeof price === 'number' && price >= 0)) {
    return false;
  }

  if (typeof billingDate === 'string') {
    return true;
  }
  return VALID_PERIODS.includes(period);
};

export const Billing = withRenderFlag({ shouldRenderFn })(_Billing);
